const pluralize = (value: number, singular: string, plural: string) =>
  `${value} ${value === 1 ? singular : plural}`;

/**
 * Formats a video length given in seconds into a Swedish natural-language
 * string, e.g. "2 minuter 34 sekunder" or "1 timme 5 sekunder".
 *
 * Returns null for values that are not a positive, finite number of seconds.
 */
export const formatVideoDuration = (totalSeconds: number | null | undefined): string | null => {
  if (totalSeconds == null || !Number.isFinite(totalSeconds) || totalSeconds <= 0) {
    return null;
  }

  const rounded = Math.round(totalSeconds);
  const hours = Math.floor(rounded / 3600);
  const minutes = Math.floor((rounded % 3600) / 60);
  const seconds = rounded % 60;

  const parts: string[] = [];
  if (hours > 0) parts.push(pluralize(hours, "timme", "timmar"));
  if (minutes > 0) parts.push(pluralize(minutes, "minut", "minuter"));
  if (seconds > 0) parts.push(pluralize(seconds, "sekund", "sekunder"));

  return parts.join(" ");
};
